function AdminPagination({
  page,
  totalPages,
  totalItems,
  rangeStart,
  rangeEnd,
  onPageChange,
}) {
  if (totalItems === 0) {
    return null;
  }

  return (
    <div className="admin-pagination">
      <p className="admin-pagination__info">
        Showing {rangeStart}–{rangeEnd} of {totalItems}
      </p>
      <div className="admin-pagination__controls">
        <button
          type="button"
          className="admin-pagination__btn"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
        >
          Previous
        </button>
        <span className="admin-pagination__page">
          Page {page} of {totalPages}
        </span>
        <button
          type="button"
          className="admin-pagination__btn"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default AdminPagination;
